import { TableColumn } from '@silverfort/sf-components/dist/Table/interface';
import { RiskEntity } from '../../../api/types/RiskEntities';
import { useEffect, useState } from 'react';
import IdentifierColumn from './IdentifierColumn';
import RiskLevelColumn from './RiskLevelColumn';
import RiskIndicatorsColumn from './RiskIndicatorsColumn';

const useGetColumns = () => {
    const [columns, setColumns] = useState<TableColumn<RiskEntity>[]>([]);

    useEffect(() => {
        setColumns([
            {
                columnKey: 'name',
                title: 'Name',
                render: (row) => <IdentifierColumn {...row} />
            },
            {
                columnKey: 'risk_level',
                title: 'Risk level',
                render: (row) => <RiskLevelColumn riskLevel={row.risk_level} />
            },
            {
                columnKey: 'domain_name',
                title: 'Domain name'
            },
            {
                columnKey: 'risk_indicators',
                title: 'Risk indicators',
                render: RiskIndicatorsColumn
            },
            {
                columnKey: 'incidents_count',
                title: '# Incident'
            }
        ]);
    }, []);

    return columns;
};

export default useGetColumns;
